import {
    FormsState,
    FormsActionTypes,

    FETCH_FORM_STARTED,
    FETCH_FORM_ERROR,
    FETCH_FORM_INSTANCES_SUCCESS,
    FETCH_FORM_FIELDS_SUCCESS,
    FETCH_FORM_DATA_SUCCESS,
    PUT_FORM_DATA,
    POST_FORM_DATA,
    DELETE_FORM_DATA
  } from "./types";
import { clone } from "../categories/functions";
import { finder, formCreator } from "./functions";
import { FormData } from './types'
const initialState: FormsState = {
    forms: [],
    isFetching: false,
    error: {}
};

export function formsReducer(
    state=initialState,
    action: FormsActionTypes
):FormsState {
    let formIndex;
    let tempState: FormsState;
    switch(action.type){
        case FETCH_FORM_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case FETCH_FORM_ERROR:
            return Object.assign({}, state, {
                error: action.error
            })
        case FETCH_FORM_FIELDS_SUCCESS:
            formIndex = finder(action.formId,state.forms);
            tempState = clone(state);

            if(formIndex != -1) {
                tempState.forms[formIndex].formFields = action.formFields;
            } else {
                let newForm = formCreator(action.formId,action.formTitle, action.description);
                newForm.formFields = action.formFields;
                tempState.forms.push(newForm);
            }

            tempState.isFetching = false;
            return tempState;

        case FETCH_FORM_DATA_SUCCESS:
            let formDataIndex = -1;
            formIndex = finder(action.formId,state.forms);
            tempState = clone(state);
            let tempFormData: FormData = {
                id: action.id,
                items: action.formDataFields,
                signature: action.signature
            }
            if(formIndex != -1) {
                formDataIndex = finder(action.id,state.forms[formIndex].formDatas);
                if(formDataIndex == -1) {
                    tempState.forms[formIndex].formDatas.push(tempFormData);
                } else {
                    tempState.forms[formIndex].formDatas[formDataIndex] = tempFormData;
                }
            } else {
                let newForm = formCreator(action.formId,action.formTitle);
                newForm.formDatas.push(tempFormData);
                tempState.forms.push(newForm);
            }

            tempState.isFetching = false;
            return tempState;
        case FETCH_FORM_INSTANCES_SUCCESS:
            formIndex = finder(action.formId,state.forms);
            tempState = clone(state);
            if(formIndex != -1) {
                tempState.forms[formIndex].dataSource = action.dataSource;
                tempState.forms[formIndex].columns = action.columns;
            } else {
                let newForm = formCreator(action.formId,action.formTitle);
                newForm.dataSource = action.dataSource;
                newForm.columns = action.columns;
                newForm.description = action.description;
                tempState.forms.push(newForm);
            }

            tempState.isFetching = false;
            return tempState;
        case PUT_FORM_DATA:
            let formDataIndex_p = -1;
            formIndex = finder(action.formId,state.forms);
            tempState = clone(state);
            if(formIndex != -1) {
                formDataIndex_p = finder(action.id,state.forms[formIndex].formDatas);
                tempState.forms[formIndex].columns = [];
                tempState.forms[formIndex].dataSource = [];
                if(formDataIndex_p != -1) {
                    tempState.forms[formIndex].formDatas.splice(formDataIndex_p,1);
                }
            }
            tempState.isFetching = false;
            return tempState;
        case POST_FORM_DATA:
            formIndex = finder(action.formId,state.forms);
            tempState = clone(state);
            if(formIndex != -1) {
                tempState.forms[formIndex].columns = [];
                tempState.forms[formIndex].dataSource = [];
            }
            tempState.isFetching = false;
            return tempState;
        default:
            return state;
    }

} 